module.exports = __webpack_public_path__ + "static/media/email.0b3bc6ab.png";